import { Theme, LOCAL_STORAGE_THEME_KEY } from "shared-types";

export function initTailwindTheme() {
  document.documentElement.classList.toggle(
    Theme.Dark,
    localStorage.theme === Theme.Dark ||
      (!(LOCAL_STORAGE_THEME_KEY in localStorage) &&
        window.matchMedia("(prefers-color-scheme: dark)").matches)
  );
}
